import React from 'react';
import './Core.css';
import { FaLaptopCode, FaUsers } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const WorkWithUs = () => {
    const navigate = useNavigate();

    return (
        <div className="work-section">
            <div className="intro">
                <h2> <span>Work </span>with Us</h2>
                <p> We offer comprehensive training and mentorship for those eager to learn
                    . Our internship program serves as the ideal entry point for students and recent graduates seeking real,
                    hands-on experience.
                    Experienced professionals looking to expand their skills or explore new roles are also welcome to apply.</p>
            </div>

            <div className="card-container">
                <div className="work-card">
                    <FaLaptopCode className="icon" />
                    <h3>IT Department</h3>
                    <p>We are hiring developers, testers, DevOps engineers, and cloud professionals
                        to build scalable digital solutions.



                    </p>
                </div>

                <div className="work-card">
                    <FaUsers className="icon" />
                    <h3>Non-IT Department</h3>
                    <p>We are hiring for positions across departments including:

                        Fabrication & Welding

                        CNC Machine Operators

                        Metal Design & Prototyping

                        Workshop Supervisors & Quality Controllers

                        Maintenance & Logistics Staff</p>
                </div>
            </div>

            <div className="contact-cta">
                <button onClick={() => navigate('/ContactUs')} className="contact-btn">Contact Us</button>
            </div>
        </div>
    );
};

export default WorkWithUs;
